import { useId } from 'react';
import useTranslation from '~/hooks/useTranslation';
import formStyles from '~/styles/form.module.css';
import cnh from '~/helpers/cnh';

type Props = {
  pax: number;
  setPax: (pax: number) => void;
  minPax: number;
};

export default function CalendarPax({
  pax,
  setPax,
  minPax,
}: Props) {
  const paxFormFieldId = useId();
  const translate = useTranslation();

  return (
    <>
      <label htmlFor={paxFormFieldId} className={formStyles.formLabel}>
        {translate('calendar.pax')}
      </label>
      <input
        className={cnh(formStyles.formControl, formStyles.formControlSmall)}
        id={paxFormFieldId}
        type="number"
        value={pax}
        min={minPax}
        onChange={(e) => setPax(Number(e.target.value))}
      />
    </>
  );
}
